import { render, staticRenderFns } from "./reportview.vue?vue&type=template&id=2a31a0a9&"
import script from "./reportview.vue?vue&type=script&lang=js&"
export * from "./reportview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports